<!-- @format -->

<template>
  <b-card title="会员排行">
    <template v-if="swiperData.length > 0">
      <div class="container">
        <swiper :options="swiperOptions" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'">
          <swiper-slide v-for="item in swiperData" :key="item.img" style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
            <template v-if="item.img && item.title">
              <el-image :src="item.img" style="width: 120px; height: 120px">
                <template slot="error">
                  <div style="width: 100%; height: 100%">
                    <img :src="defaultImage" alt="" style="width: 100%; height: 100%" />
                  </div>
                </template>
              </el-image>
              <div style="width: 100%; text-align: center; margin-top: 20px">{{ item.title }} {{ item.real_name }}</div>
            </template>
            <template v-else>
              <BAvatar :src="require('@/assets/images/illustration/badge.svg')" style="width: 120px; height: 120px" alt="加载失败" />
              <div style="width: 100%; text-align: center; margin-top: 20px">{{ item.title }},虚位以待</div>
            </template>
          </swiper-slide>
          <div slot="pagination" class="swiper-pagination" />
          <div slot="button-next" class="swiper-button-next" />
          <div slot="button-prev" class="swiper-button-prev" />
        </swiper>
      </div>
    </template>
    <template v-else>
      <swiper class="swiper-autoplay" :options="swiperOptions" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'">
        <swiper-slide style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
          <img :src="require('@/assets/images/illustration/badge.svg')" style="width: 120px; height: 120px" alt="加载失败" />
          <div style="width: 100%; text-align: center; margin-top: 20px">招募之星,虚位以待</div>
        </swiper-slide>
        <swiper-slide style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
          <img :src="require('@/assets/images/illustration/badge.svg')" style="width: 120px; height: 120px" alt="加载失败" />
          <div style="width: 100%; text-align: center; margin-top: 20px">接单之星,虚位以待</div>
        </swiper-slide>
        <swiper-slide style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
          <img :src="require('@/assets/images/illustration/badge.svg')" style="width: 120px; height: 120px" alt="加载失败" />
          <div style="width: 100%; text-align: center; margin-top: 20px">团队之星,虚位以待</div>
        </swiper-slide>
        <swiper-slide style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
          <img :src="require('@/assets/images/illustration/badge.svg')" style="width: 120px; height: 120px" alt="加载失败" />
          <div style="width: 100%; text-align: center; margin-top: 20px">业绩之星,虚位以待</div>
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination" />
        <div slot="button-next" class="swiper-button-next" />
        <div slot="button-prev" class="swiper-button-prev" />
      </swiper>
    </template>

    <template #code>
      {{ codeAutoplay }}
    </template>
  </b-card>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { BImg, BCard, BAvatar } from 'bootstrap-vue'
import 'swiper/css/swiper.css'
import { codeAutoplay } from './code'

export default {
  components: {
    Swiper,
    SwiperSlide,
    BImg,
    BCard,
    BAvatar,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defaultImage: `${process.env.VUE_APP_COM_URL}/static/default-avatar.png`,
      codeAutoplay,
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 114000,
          disableOnInteraction: false,
        },
        pagination: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperData: [],
    }
  },
  watch: {
    data: {
      handler(val) {
        const endData = []
        val = {
          team_star: {
            user_id: null,
            money: null,
            member2: null,
          },
          yeji_star: {
            id: 51,
            real_name: '张三12',
            avatar: 'http://api.myonewow.com/images/user/avatar/20220718/2b4f06c83ebdc66b72b23f2c215ff7a2.png',
            all_tp: '15000.00',
          },
          order_star: {
            user_id: 56,
            total: 3,
            member: {
              id: 56,
              real_name: '张三',
              avatar: 'http://api.myonewow.com/images/user/avatar/20220718/9814e579f73181f8934863ed18a5f956.png',
            },
          },
          invite_star: {
            id: 300091,
            real_name: 'LiPeiran',
            avatar: 'http://api.myonewow.com/',
            child_num: 20,
          },
        }
        // endData[0] = { img: val?.invite_star?.avatar, title: '招募之星' }
        // endData[1] = { img: val?.order_star?.member?.avatar, title: '接单之星' }
        // endData[2] = { img: val?.team_star?.member2?.avatar, title: '团队之星' }
        // endData[3] = { img: val?.yeji_star?.avatar, title: '业绩之星' }

        // 注意判断空
        if (val?.invite_star?.avatar) {
          endData[0] = { img: val?.invite_star?.avatar, title: '招募之星', real_name: val?.invite_star?.real_name }
        } else {
          endData[0] = { img: undefined, title: '招募之星' }
        }
        if (val?.order_star?.member?.avatar) {
          endData[1] = { img: val?.order_star?.member?.avatar, title: '接单之星', real_name: val?.order_star?.member?.real_name }
        } else {
          endData[1] = { img: undefined, title: '接单之星' }
        }
        if (val?.team_star?.member2?.avatar && val?.team_star?.member2?.user_id) {
          endData[2] = { img: val?.team_star?.member2?.avatar, title: '团队之星', real_name: val?.team_star?.member2?.real_name }
        } else {
          endData[2] = { img: undefined, title: '团队之星' }
        }
        if (val?.yeji_star?.avatar) {
          endData[3] = { img: val?.yeji_star?.avatar, title: '业绩之星', real_name: val?.yeji_star?.real_name }
        } else {
          endData[3] = { img: undefined, title: '业绩之星' }
        }
        this.swiperData = endData
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.xieburo {
  .b-avatar-custom {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #fff !important;
  }
}
</style>
